import flkty from "flickity";

export function partnersSlider() {
    const containers = document.querySelectorAll('.partners__container');

    if (!containers) {
        return;
    }

    containers.forEach((container) => {
        new flkty(container, {
            contain: true,
            draggable: '>1',
            freeScroll: true,
            prevNextButtons: false,
            watchCSS: true,
        })
    })
}
